/* Quote / availability request form (owner, 2026-11-01). Opens on every "[3JIndustry RFQ]" e-mail link of the theme and sends
   the request to the 3JIndustry request system, which answers with a case number (RFQ-YYYYMMDD-NNNN) and e-mails the customer
   and the sales team. Any failure keeps the original e-mail link available. No cookie, no tracking. */
(function () {
  'use strict';
  var dlg = document.getElementById('QuoteDialog');
  if (!dlg || typeof dlg.showModal !== 'function' || !window.fetch) return;   // old browser: the e-mail links keep working
  var form = dlg.querySelector('form'), done = dlg.querySelector('.qf__done'), err = dlg.querySelector('.qf__error');
  var fallback = dlg.querySelector('.qf__fallback'), mailLink = dlg.querySelector('[data-qf-mail]'), submit = dlg.querySelector('[data-qf-submit]');
  var title = dlg.querySelector('.qf__title'), d = dlg.dataset, currentHref = '', availability = false, prefilledPart = '';

  function rfqSubject(href) {
    try {
      var q = href.split('?')[1] || '';
      var m = /(?:^|&)subject=([^&]*)/.exec(q);
      return m ? decodeURIComponent(m[1].replace(/\+/g, '%20')) : '';
    } catch (e) { return ''; }
  }
  function partFrom(subject) {
    // "[3JIndustry RFQ] Quote request: ABB MS132 …" -> "ABB MS132 …"; the general request has no part
    var m = /\]\s*[^:：]*[:：]\s*(.+)$/.exec(subject);
    return m ? m[1].trim() : '';
  }
  function show(el, on) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); }
  function reset() {
    form.reset(); show(form, true); show(done, false); show(err, false); show(fallback, false);
    submit.disabled = false; submit.textContent = d.send;
  }
  function open(href) {
    var subject = rfqSubject(href);
    availability = /availab|disponib|disponibilidad|到货|可用/i.test(subject.split(/[:：]/)[0] || '');
    currentHref = href; reset();
    title.textContent = availability ? d.tAvail : d.tQuote;
    prefilledPart = partFrom(subject);
    form.elements.part.value = prefilledPart;
    mailLink.setAttribute('href', href);
    dlg.showModal();
    (form.elements.part.value ? form.elements.quantity : form.elements.part).focus();
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href^="mailto:"]') : null;
    if (!a) return;
    var href = a.getAttribute('href');
    if (rfqSubject(href).indexOf('[3JIndustry RFQ]') !== 0) return;   // other e-mail links (contact) stay e-mail links
    e.preventDefault();
    open(href);
  });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || (e.target.closest && e.target.closest('[data-qf-close]'))) dlg.close();
  });

  function fail(text, offerMail) {
    err.textContent = text; show(err, true); show(fallback, !!offerMail);
    submit.disabled = false; submit.textContent = d.send;
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = form.elements;
    if (f.website.value) { dlg.close(); return; }   // honeypot
    var qty = Math.floor(Number(f.quantity.value));
    if (!f.part.value.trim() || !f.name.value.trim() || !f.country.value.trim() || !(qty >= 1 && qty <= 10000) || !f.email.checkValidity() || !f.email.value.trim()) {
      fail(d.errCheck, false); return;
    }
    var lines = [d.lCountry + ': ' + f.country.value.trim()];
    if (f.postal.value.trim()) lines.push(d.lPostal + ': ' + f.postal.value.trim());
    if (f.address.value.trim()) lines.push(d.lAddress + ': ' + f.address.value.trim());
    if (availability) lines.push(d.lAvail);
    if (f.notes.value.trim()) lines.push('', 'Notes:', f.notes.value.trim());
    var payload = {
      email: f.email.value.trim(), name: f.name.value.trim(), locale: d.locale,
      lines: [{ description: f.part.value.trim().slice(0, 480), quantity: qty }],
      message: lines.join('\n').slice(0, 3900)
    };
    payload.country = f.country.value.trim().slice(0, 80);
    if (f.postal.value.trim()) payload.postalCode = f.postal.value.trim().slice(0, 20);
    // the product page the request was sent from (only when the part was not changed): the confirmation e-mail can offer the
    // "buy online" link when the product is for sale
    if (d.productUrl && prefilledPart && f.part.value.trim() === prefilledPart) {
      payload.productUrl = d.productUrl; payload.productAvailable = d.productAvailable === '1';
    }
    if (f.company.value.trim()) payload.company = f.company.value.trim();
    if (f.phone.value.trim()) payload.phone = f.phone.value.trim();
    show(err, false); show(fallback, false);
    submit.disabled = true; submit.textContent = d.sending;
    fetch(d.api, { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; });
      })
      .then(function (res) {
        if (res.status === 201 && res.body && res.body.number) {
          dlg.querySelector('[data-qf-number]').textContent = res.body.number;
          dlg.querySelector('[data-qf-email]').textContent = payload.email;
          show(form, false); show(done, true);
          return;
        }
        if (res.status === 429) fail(d.errMany, true);
        else if (res.status === 400) fail(d.errCheck, true);
        else fail(d.err, true);
      })
      .catch(function () { fail(d.err, true); });
  });
})();
